import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../actions/appusers";
import * as userActionCreators from "../actions/userActivity";
import { Mixpanel } from "../mixpanel";
import _ from "lodash";
import IconEmail from "material-ui/svg-icons/communication/email";
import RaisedButton from "material-ui/RaisedButton";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import AppFrame from "./Appframe/AppFrame";
import Title from "../components/common/Title";
import AppUsersList from "../components/common/UsersListV2";
import PushNotificationSender from "../components/common/PushNotificationSender";
import ActionDialogue from "../components/common/ActionDialogue";
import AlertDialog from "../components/common/AlertDialog";
import WrapDialogue from "../components/common/WrapDialogue";
import colors from "../styles/colors";
import { colorsV2 } from "../styles/colors";
import layout from "../styles/layout";
import "../resources/styles/ManageUsers.css";
import events from "../services/events";

class ManageUsers extends Component {
  constructor(props) {
    super(props);

    let appId = props.match.params.appId;
    let appInfo = this.props.apps.appInfos[appId];
    this.state = {
      appId,
      appInfo,
      appUsers: [],
      removeUserDialogueData: {},
      width: 0,
      height: 0,
      anchorEl: null,
      showAll: false,
      activeCount: 0,
      dischargedCount: 0,
      removedCount: 0,
      totalCount: 0,
      alert: {
        open: false,
        title: "",
        message:
          ""
      }
    };

    this.manageUserPlaybook = this.manageUserPlaybook.bind(this);
    this.removeUserFromApp = this.removeUserFromApp.bind(this);
    this.removeUserConfirmationDialogue =
      this.removeUserConfirmationDialogue.bind(this);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidMount() {
    Mixpanel.track("View manage users page", {
      "Channel Name": this.state.appInfo ? this.state.appInfo.appName : "",
      "Channel ID": this.state.appId,
      "App Type": this.state.appInfo ? this.state.appInfo.appType : "",
    });
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener(
      "resize",
      this.updateWindowDimensions.bind(this)
    );
  }

  componentWillMount() {
    this.props.getAppUsers(this.props.userId, this.state.appId);
  }

  componentWillReceiveProps(nextProps) {
    let appInfo = nextProps.apps.appInfos[this.state.appId];
    if (appInfo) {
      this.setState({ appInfo });
    }
    if (nextProps.appusers && nextProps.appusers.appUsers) {
      let appUsers = nextProps.appusers.appUsers[this.state.appId];
      if (appUsers) {
        let activeCount = 0;
        let dischargedCount = 0;
        let removedCount = 0;
        appUsers.map((user) => {
          if (user.hasAccess && !user.isDischarged) {
            activeCount++;
          } else if (user.isDischarged && user.hasAccess) {
            dischargedCount++;
          } else {
            removedCount++;
          }
        });
        this.setState({
          appUsers,
          activeCount,
          dischargedCount,
          removedCount,
          totalCount: appUsers.length,
        });
      }
    }
  }

  addUserToSelection(user) {
    let broadcastUsers = this.state.selectedBroadcastUsers
      ? this.state.selectedBroadcastUsers
      : [];
    let found = broadcastUsers.filter((u) => u === user);
    if (!found.length > 0) {
      broadcastUsers.push(user);
    }
    this.setState({ selectedBroadcastUsers: broadcastUsers });
  }

  removeUserToSelection(user) {
    if (this.state.selectedBroadcastUsers) {
      const filteredList = this.state.selectedBroadcastUsers.filter(
        (u) => u !== user
      );
      this.setState({ selectedBroadcastUsers: filteredList });
    }
  }

  sendPushNotification() {
    let windowTitle = `Message Selected Users`;
    return (
      <div>
        <RaisedButton
          primary={!this.props.whiteLabelSettings.isWhiteLabel}
          label="Send Notification and Email"
          icon={<IconEmail />}
          onClick={() => this.refs.selectList.open()}
        />
        <WrapDialogue
          ref="selectList"
          title={windowTitle}
          content={
            <div>
              <div style={{ marginBottom: 20 }}>
                <AppUsersList
                  users={this.state.appUsers.filter((user) =>
                    user.hasAccess ? true : false
                  )}
                  allowRemove={true}
                  onClick={(user) => this.addUserToSelection(user)}
                  onDelete={(user) => this.removeUserToSelection(user)}
                  selectedUsers={this.state.selectedBroadcastUsers}
                  onSelectAll={(users) => {
                    this.setState({ selectedBroadcastUsers: users });
                  }}
                />
              </div>

              <RaisedButton
                style={{
                  position: "absolute",
                  bottom: 15,
                  right: 15,
                  marginTop: 20,
                }}
                primary={!this.props.whiteLabelSettings.isWhiteLabel}
                disabled={
                  !this.state.selectedBroadcastUsers ||
                  this.state.selectedBroadcastUsers.length < 1
                }
                label="Next"
                onClick={() => {
                  this.refs.selectList.close();
                  this.refs.sendPushNotificationDialogue.open();
                }}
              />
            </div>
          }
        />

        <WrapDialogue
          ref="sendPushNotificationDialogue"
          title={windowTitle}
          content={
            <PushNotificationSender
              type="selected"
              userId={this.props.userId}
              selectedList={this.state.selectedBroadcastUsers}
              appId={this.state.appId}
              appCode={this.props.whiteLabelSettings.appCode}
              sender={this.state.appInfo ? this.state.appInfo.author : ""}
              subject={""}
              onComplete={() => {
                this.refs.sendPushNotificationDialogue.close();
                this.setState({ selectedBroadcastUsers: [] });
              }}
            />
          }
        />
      </div>
    );
  }

  handleEnrollUser(userId, appId) {
    this.props.enrollAppUser(userId, appId).then((result) => {
      console.log(result, "enroll user result");
      if (result && result.overLimit) {
        this.setState({ showLimitDialog: true });
        this.setState({ alert: {
          open: true,
          title: "Patient Limit Reached",
          message:
            <span>
              Your patient limit has been reached under your current plan. <br /> Please <a href="https://ac-health.com/ac-health-pricing/" target="_blank" rel="noopener noreferrer">click here</a> to view available plans and upgrade your subscription, or reach out to <a href='mailto:info@ac-health.com'>info@ac-health.com</a>.
            </span>,
        }});
      }
    });
  }

  closeAlertDialog = () => {
    this.setState({ alert: { ...this.state.alert, open: false }});
  }

  manageUserPlaybook(user) {
    //Only Allow Standard Channels To Load the Care Plan Screen for A Patient
    if (
      this.props.apps.appInfos[this.props.apps.providerAppId].appType ===
      "Standard"
    ) {
      //Get and Load user Data + Start Timer
      if (
        this.props.apps.appInfos[this.props.apps.providerAppId]
          .autoTrackTimeInChart
      ) {
        this.props.requestLoadAppTimer(this.props.userId, user.customAppId);
      }

      setTimeout(() => {
        let link = `/manage-user-customapp/${this.state.appId}/${user.userId}`;
        events().trackUserEvent(
          "View Channel",
          this.state.appId,
          user.customAppId,
          null,
          null,
          this.props.userId,
          null,
          "portal",
          this.props.apps.appInfos[this.props.apps.providerAppId].appName,
          null,
          null
        );
        this.props.history.push(link);
      }, 2000);
    }
  }

  removeUserFromApp(userId, appId, appUser) {
    let userName = appUser.userInfo.lastName
      ? `${appUser.userInfo.firstName} ${appUser.userInfo.lastName}`
      : appUser.userInfo.email;

    this.setState({
      removeUserDialogueData: {
        userId,
        appId,
        appUserId: appUser.userId,
        userName,
      },
    });
    this.refs.removeUserConfDialogue.open();
  }

  dischargeUserFromApp(userId, appId, appUser) {
    let userName = appUser.userInfo.lastName
      ? `${appUser.userInfo.firstName} ${appUser.userInfo.lastName}`
      : appUser.userInfo.email;

    this.setState({
      removeUserDialogueData: {
        userId,
        appId,
        appUserId: appUser.userId,
        userName,
      },
    });
    this.refs.dischargeUserConfDialogue.open();
  }

  removeUserConfirmationDialogue() {
    let data = this.state.removeUserDialogueData;
    let title = `Remove patient ${data.userName}`;

    return (
      <ActionDialogue
        ref="removeUserConfDialogue"
        title={title}
        content="Be careful, this action will also remove access for the patient!"
        onConfirm={() =>
          this.props.dischargeAppUserNoAccess(
            data.userId,
            data.appId,
            data.appUserId
          )
        }
      />
    );
  }

  dischargeUserConfirmationDialogue() {
    let data = this.state.removeUserDialogueData;
    let title = `Discharge patient ${data.userName}`;

    return (
      <ActionDialogue
        ref="dischargeUserConfDialogue"
        title={title}
        content="Patient will be discharged but still have access to their care plan."
        onConfirm={() =>
          this.props.dischargeAppUser(data.userId, data.appId, data.appUserId)
        }
      />
    );
  }

  handleMoreOptions = (event) => {
    event.stopPropagation();
    this.setState({
      anchorEl: event.currentTarget,
    });
  };
  getStatusForUser = (user) => {
    if (!user.hasAccess) {
      return "Removed";
    } else if (user.hasAccess && user.isDischarged) {
      return "Discharged";
    } else {
      return "Active";
    }
  };

  render() {
    let numUsers = _.size(this.state.appUsers);
    let targetDevice = "desktop";
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      targetDevice = "mobile";
    }

    return (
      <React.Fragment>
         <AlertDialog
            open={this.state.alert.open}
            onClose={this.closeAlertDialog}
            title={this.state.alert.title}
            message={this.state.alert.message}
          />
        <AppFrame
          auth={this.props.auth}
          header={"Manage Users"}
          optionsType={"manage-users"}
          whiteLabelSettings={this.props.whiteLabelSettings}
        >
          <Title
            whiteLabelSettings={this.props.whiteLabelSettings}
            goBack={() => this.props.history.goBack()}
          />
          <div style={{ ...layout.common.page, width: "100%" }}>
            <div style={layout.common.mainContainer}>
              <div style={layout.common.filterRow}>
                <div style={layout.common.searchField}>
                  <TextField
                    id="filled-full-width"
                    label="Search"
                    style={{ margin: 8 }}
                    placeholder="Search By Name"
                    fullWidth
                    margin="normal"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    value={this.state.searchText}
                    onChange={(e) => {
                      this.setState({ searchText: e.target.value });
                    }}
                  />
                  <IconButton
                    color="primary"
                    aria-label="Clear Search"
                    component="span"
                    onClick={() => this.setState({ searchText: "" })}
                    style={layout.common.searchFieldCancel}
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
                <div style={{}}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.showAll}
                        onChange={(val) => {
                          const curVal = this.state.showAll;
                          this.setState({ showAll: !curVal });
                        }}
                        name="toggleAll"
                        color="primary"
                      />
                    }
                    label="Show All"
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "92%",
                    padding: 10,
                  }}
                >
                  {this.sendPushNotification()}
                </div>
              </div>
              <div className="manage_user_counts_row">
                <div className="manage_user_counts_box">
                  <h2 className="manage_user_counts_number">
                    {this.state.activeCount}
                  </h2>
                  Active Patients
                </div>
                <div className="manage_user_counts_box">
                  <h2 className="manage_user_counts_number">
                    {this.state.dischargedCount}
                  </h2>
                  Discharged Patients
                </div>
                <div className="manage_user_counts_box">
                  <h2 className="manage_user_counts_number">
                    {this.state.totalCount}
                  </h2>
                  Total Patients
                </div>
              </div>

              <div className="user__table_container">
                <table className="user__table">
                  <tr>
                    <th></th>
                    <th
                      style={{
                        color: this.props.whiteLabelSettings.isWhiteLabel
                          ? this.props.whiteLabelSettings.accentColor
                          : "",
                      }}
                    >
                      Patient Name
                    </th>
                    <th
                      style={{
                        color: this.props.whiteLabelSettings.isWhiteLabel
                          ? this.props.whiteLabelSettings.accentColor
                          : "",
                      }}
                    >
                      Email
                    </th>
                    <th
                      style={{
                        color: this.props.whiteLabelSettings.isWhiteLabel
                          ? this.props.whiteLabelSettings.accentColor
                          : "",
                      }}
                    >
                      Status
                    </th>
                    <th
                      style={{
                        color: this.props.whiteLabelSettings.isWhiteLabel
                          ? this.props.whiteLabelSettings.accentColor
                          : "",
                      }}
                    >
                      Actions
                    </th>
                  </tr>
                  {this.state.appUsers
                    .filter((user) => {
                      if (this.state.showAll) {
                        return true;
                      } else {
                        if (!user.hasAccess) {
                          return false;
                        } else {
                          return true;
                        }
                      }
                    })
                    .filter((user) => {
                      const fName =
                        (user.userInfo.firstName ? user.userInfo.firstName : "") +
                        " " +
                        (user.userInfo.lastName ? user.userInfo.lastName : "");
                      return this.state.searchText
                        ? fName
                            .toLowerCase()
                            .includes(this.state.searchText.toLowerCase())
                        : true;
                    })
                    .sort((a, b) => {
                      if (
                        !a.userInfo.lastName ||
                        !b.userInfo.lastName ||
                        !a.userInfo.firstName ||
                        !b.userInfo.firstName
                      ) {
                        return 0;
                      }
                      if (
                        a.userInfo.lastName.toLowerCase() <
                        b.userInfo.lastName.toLowerCase()
                      ) {
                        return -1;
                      }
                      if (
                        b.userInfo.lastName.toLowerCase() <
                        a.userInfo.lastName.toLowerCase()
                      ) {
                        return 1;
                      }
                      // a must be equal to b
                      if (
                        a.userInfo.firstName.toLowerCase() <
                        b.userInfo.firstName.toLowerCase()
                      ) {
                        return -1;
                      }
                      if (
                        b.userInfo.firstName.toLowerCase() <
                        a.userInfo.firstName.toLowerCase()
                      ) {
                        return 1;
                      }
                      return 0;
                    })
                    .map((user) => (
                      <tr>
                        <td
                          onClick={() => {
                            this.manageUserPlaybook(user);
                          }}
                        >
                          <div
                            className="user__avatar"
                            style={{
                              backgroundImage: `url(${user.userInfo.profilePhotoUrl})`,
                            }}
                          ></div>
                        </td>
                        <td
                          onClick={() => {
                            this.manageUserPlaybook(user);
                          }}
                        >
                          {user.userInfo.firstName ? user.userInfo.firstName : ""}{" "}
                          {user.userInfo.lastName ? user.userInfo.lastName : ""}
                        </td>

                        <td
                          onClick={() => {
                            this.manageUserPlaybook(user);
                          }}
                        >
                          <span>{user.userInfo.email}</span>
                        </td>
                        <td
                          onClick={() => {
                            this.manageUserPlaybook(user);
                          }}
                        >
                          <span>{this.getStatusForUser(user)}</span>
                        </td>
                        <td
                          style={{
                            displah: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignContent: "center",
                          }}
                        >
                          {(!user.hasAccess || user.isDischarged) && (
                            <Button
                              variant="outlined"
                              style={{
                                color: this.props.whiteLabelSettings.isWhiteLabel
                                  ? this.props.whiteLabelSettings.accentColor
                                  : colorsV2.primary,
                                cursor: "pointer",
                                marginRight: 10,
                              }}
                              onClick={() => {
                                this.handleEnrollUser(
                                  this.state.appId,
                                  user.userId
                                );
                                events().trackUserEvent(
                                  "Activate User",
                                  this.state.appId,
                                  null,
                                  null,
                                  null,
                                  this.props.userId,
                                  user.userId,
                                  "portal",
                                  this.state.appInfo.appName,
                                  null,
                                  null
                                );
                              }}
                            >
                              Activate
                            </Button>
                          )}
                          {!user.isDischarged && user.hasAccess && (
                            <Button
                              variant="outlined"
                              style={{
                                color: this.props.whiteLabelSettings.isWhiteLabel
                                  ? this.props.whiteLabelSettings.accentColor
                                  : colorsV2.primary,
                                cursor: "pointer",
                                marginRight: 10,
                              }}
                              onClick={() => {
                                this.dischargeUserFromApp(
                                  this.props.userId,
                                  this.state.appId,
                                  user
                                );

                                events().trackUserEvent(
                                  "Discharge User",
                                  this.state.appId,
                                  null,
                                  null,
                                  null,
                                  this.props.userId,
                                  user.userId,
                                  "portal",
                                  this.state.appInfo.appName,
                                  null,
                                  null
                                );
                              }}
                            >
                              Discharge
                            </Button>
                          )}

                          {user.hasAccess && (
                            <Button
                              variant="outlined"
                              style={{
                                color: colors.red,
                                cursor: "pointer",
                                marginRight: 10,
                              }}
                              onClick={() => {
                                this.removeUserFromApp(
                                  this.props.userId,
                                  this.state.appId,
                                  user
                                );

                                events().trackUserEvent(
                                  "Remove User",
                                  this.state.appId,
                                  null,
                                  null,
                                  null,
                                  this.props.userId,
                                  user.userId,
                                  "portal",
                                  this.state.appInfo.appName,
                                  null,
                                  null
                                );
                              }}
                            >
                              Remove
                            </Button>
                          )}
                        </td>
                      </tr>
                    ))}
                </table>
              </div>
            </div>
            {this.removeUserConfirmationDialogue()}
            {this.dischargeUserConfirmationDialogue()}
          </div>
        </AppFrame>
      </React.Fragment>
    );
  }
}

function mapStateToProps({ user, apps, appusers, whiteLabelSettings }) {
  return {
    userId: user.userId,
    apps,
    appusers,
    whiteLabelSettings,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...actionCreators, ...userActionCreators },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageUsers);



// WEBPACK FOOTER //
// ./src/layout/ManageUsers.js